import { ReactNode } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useElementContext } from "@ultracommerce/react-storefront/global";

export const HeaderContentFour = ({
  theme,
  siteSetting,
  filteredMenus = [],
}: {
  theme: any;
  siteSetting: any;
  filteredMenus: ReactNode[];
}) => {
  const { t } = useTranslation();
  const {
    CommonModule: { MobileHeader, SearchBar },
  } = useElementContext();

  return (
    <div className="row col-12 align-items-center justify-content-between position-relative">
      <div className="d-flex filtered-block-div col-2 col-lg-2">
        <Link className="d-block" to="/">
          <span className="navbar-brand d-block">
            {theme && theme.logo ? (
              <img
                src={`${theme.logo?.trim()}`}
                className="img-fluid navbar-brandLogo"
                alt={t("frontend.logo")}
                style={{ maxHeight: "60px", minWidth: "150px" }}
              />
            ) : null}
          </span>
        </Link>
        {theme.headerTagLine && <div className="d-none d-lg-block">{theme.headerTagLine}</div>}
      </div>

    
      <MobileHeader siteSetting={siteSetting} />

      <div className=" d-none d-lg-flex text-end col-7 justify-content-center ">
        {filteredMenus.length > 0 && <div>{filteredMenus}</div>}
   
      </div>

      <div className="d-none d-lg-flex flex-column justify-content-center col-3">
        <div className="d-lg-flex m-auto">
          <SearchBar searchBoxTypeaheadFlag redirectToSearchPage searchBoxPlaceholder={theme?.searchPlaceholder} />
          {/* {siteSetting.sitePurpose !== "Non-Transactional" && <MiniCart />} */}
        </div>
      </div>
    </div>
  );
};
